import type { Kiosk } from '@gozoki/api-types'
import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { fetchCheckoutKiosks } from '../queries/checkoutKiosk.queries'

export const useCheckoutKiosks = (storeId: number): UseQueryResult<Kiosk[], unknown> =>
  useQuery({
    queryKey: ['checkout', storeId],
    queryFn: () => fetchCheckoutKiosks(storeId),
    refetchInterval: 5000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  })
